export { default as GigAssFooter } from './GigAssFooter'
